import Favorite from "../Components/Favorite";

function FavoriteGifs(){
    return(
        <Favorite />
    )
}
export default FavoriteGifs;